module.exports = __webpack_public_path__ + "static/media/Michael Lee.6b894912.png";